import _ from 'lodash'
import React from 'react'
import CitySummary from './CitySummary'

let History = ({ ddHistory }) => {
  return !ddHistory.length ? (
    <div>No history is currently saved.</div>
  ) : (
    _.sortBy(
      ddHistory,
      h => -h.dateCreated
    ).map(({ id, dateCreated, termsArray, citySummary }) => (
      <CitySummary
        key={id}
        docId={id}
        dateCreated={dateCreated}
        termsArray={termsArray}
        citySummary={citySummary}
        showSaveHistory={false}
        showDeleteHistory
        showExpandBtn
      />
    ))
  )
}

export default History
